import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";

import { Account } from "@/entities/auth/Account";
import { Role } from "@/entities/auth/Role";
import { UserService } from "@/services/userService";
import Login from "@/views/Login.vue";
import Home from "@/views/Home.vue";
import ExpertHome from "@/views/expert/ExpertHome.vue";
import EditTool from "@/views/expert/EditTool.vue";
import NewTool from "@/views/expert/NewTool.vue";
import Voting from "@/views/expert/voting/Voting.vue";
import VotingTable from "@/views/expert/voting/VotingTable.vue";
import VotingDetail from "@/views/expert/voting/VotingDetail.vue";
import SelfCheck from "@/views/expert/SelfCheck.vue";
import AdminHome from "@/views/admin/AdminHome.vue";
import SystemSettings from "@/views/admin/SystemSettings.vue";
import EditToolTnm from "@/views/expert/EditToolTnm.vue";
import DataLoad from "@/views/admin/DataLoad.vue";
import AdminReports from "@/views/admin/AdminReports.vue";
import ExpertReports from "@/views/expert/ExpertReports.vue";
import Ratings from "@/views/expert/Ratings.vue";
import TnmConfiguration from "@/views/admin/TnmConfiguration.vue";
import AdminPanel from "@/views/admin/AdminPanel.vue";
import TestDetails from "@/views/admin/TestDetails.vue";
import { analytics } from '@/services/analytics';


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('@/views/Signup.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue')
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import('@/views/VerifyEmail.vue')
  },
  {
    path: "/",
    name: "Treatments",
    component: ExpertHome,
    meta: { authorize: [Role.Expert] },
    children: [
      {
        path: "tools/edit",
        name: "Edit treatment",
        component: EditTool,
        meta: { authorize: [Role.Expert] }
      },
      {
        path: "tools/edit-tnm",
        name: "Edit treatment TNM",
        component: EditToolTnm,
        meta: { authorize: [Role.Expert] }
      },
      {
        path: "tools/new",
        name: "New treatment",
        component: NewTool,
        meta: { authorize: [Role.Expert] }
      },
      {
        path: "tools/ratings",
        name: "Ratings",
        component: Ratings,
        meta: { authorize: [Role.Expert] }
      },
      {
        path: "voting",
        component: Voting,
        meta: { authorize: [Role.Expert] },
        children: [
          {
            path: "",
            component: VotingTable,
            meta: { authorize: [Role.Expert] }
          },
          {
            path: ":id/detail",
            name: "Voting Detail",
            component: VotingDetail,
            meta: { authorize: [Role.Expert] }
          }
        ]
      },
      {
        path: "selfcheck",
        component: SelfCheck,
        meta: { authorize: [Role.Expert] }
      },
      {
        path: "reports",
        name: "Reports",
        component: ExpertReports,
        meta: { authorize: [Role.Expert] }
      }
    ]
  },
  {
    path: "/",
    name: "Admin Home",
    component: AdminHome,
    meta: { authorize: [Role.Admin] },
    redirect: "admin/dataLoad",
    children: [
      {
        path: "admin/adminPanel",
        name: "AdminPanel",
        component: AdminPanel,
        meta: { authorize: [Role.Admin] }
      },
      {
        path: "admin/TestDetails",
        name: "Test Analysis",
        component: TestDetails,
        meta: { authorize: [Role.Admin] }
      },
      {
        path: "admin/dataLoad",
        name: "Data Load",
        component: DataLoad,
        meta: { authorize: [Role.Admin] }
      },
      {
        path: "admin/tnmConfiguration",
        name: "TNM Configuration",
        component: TnmConfiguration,
        meta: { authorize: [Role.Admin] }
      },
      {
        path: "admin/reports",
        name: "Reports",
        component: AdminReports,
        meta: { authorize: [Role.Admin] }
      },
      {
        path: "settings",
        name: "System Settings",
        component: SystemSettings,
        meta: { authorize: [Role.Admin] }
      },
      
    ]
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const currentAccount: Account | null = UserService.getAccount();
  const authorize = to.meta?.authorize;

  if (to.name === "Login" && currentAccount && !currentAccount.isExpired()) {
    return next("/");
  } else if (authorize) {
    if (currentAccount == null || currentAccount.isExpired()) {
      store.dispatch("authentication/logout");
      return next({ path: "/login", query: { returnUrl: to.fullPath } });
    }

    if (!authorize.includes(currentAccount.role)) {
      return next("/");
    }
  }

  UserService.prolongExpirationDate();
  store.dispatch("resetError");
  next();
});

router.afterEach((to, from) => {
  // Small delay to ensure page is loaded
  setTimeout(() => {
    const pageName = to.name || to.path
    analytics.trackPageView(to.path, pageName)
  }, 100)
})




export default router;
